import { Chip, ChipProps } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { SvbrgIntakeStatus } from '@/generated/gql/graphql';
import { I18nNamespace } from '~/common/types';

type ColorMap = { [key: string]: ChipProps['color'] };

const colorMap: ColorMap = {
  [SvbrgIntakeStatus.DRAFT]: 'default',
  [SvbrgIntakeStatus.RELEASED]: 'default',
  [SvbrgIntakeStatus.BLOCKED]: 'error',
  [SvbrgIntakeStatus.IN_PROGRESS]: 'success',
  [SvbrgIntakeStatus.CANCELLED]: 'default',
  [SvbrgIntakeStatus.COMPLETED]: 'success',
};

export interface IntakeStatusChipProps {
  className?: string;
  status?: keyof typeof SvbrgIntakeStatus;
}

export const IntakeStatusChip = ({ className, status }: IntakeStatusChipProps) => {
  const { t } = useTranslation(I18nNamespace.intake);
  return status ? (
    <Chip
      className={className}
      label={t(`IntakeStatus.${status}`)}
      color={colorMap[status]}
      data-intercom-target="Intake/StatusChip"
    />
  ) : null;
};
